import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ListOfficerEffects, listOfficerReducer, LIST_OFFICER_STORE_KEY } from './state';

@NgModule({
  imports: [CommonModule, StoreModule.forFeature(LIST_OFFICER_STORE_KEY, listOfficerReducer), EffectsModule.forFeature([ListOfficerEffects])],
})
export class SharedFeatureListOfficerModule {}
